import { GET_PLAYER_SCORE_LOADING, GET_PLAYER_SCORE_SUCCESS, GET_PLAYER_SCORE_ERROR } from "../../../constant/actionTypes";

const playerScoresReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_SCORE_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_PLAYER_SCORE_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case GET_PLAYER_SCORE_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default playerScoresReducer;